import React, { useState, useEffect } from 'react';
import { Dropdown } from 'react-bootstrap'
import Label, { useLabels } from "components/general/Label"
import { useUrlFriendlyToParameters, useNavigateTo } from 'helpers/urlFriendly';

export default function SelectorPdfType({ page = "", selectedPdfType, onSelectPdfType }) {
    const [textCombo, setTextCombo] = useState();
    const params = useUrlFriendlyToParameters()
    const [paramsUrl, setParamsUrl] = useState({});
    const [shouldNavigate, setShouldNavigate] = useState(false);
    useNavigateTo(paramsUrl, shouldNavigate, setShouldNavigate, page)
    const fLabel = useLabels()

    //copy parameters URL to change 
    let paramsURL = { ...params }
    const data = [
        { code: 'all-reports', label: fLabel({ data: 'AllReports' }) },
        { code: 'UNIT', label: fLabel({ data: 'EventUnitReports' }) },
        { code: 'PHASE', label: fLabel({ data: 'PhaseReports' }) },
        { code: 'EVENT', label: fLabel({ data: 'EventReports' }) },
        { code: 'DISCIPLINE', label: fLabel({ data: 'DisciplineReports' }) },
        { code: 'DATE', label: fLabel({ data: 'DateReports' }) },
        { code: 'COMMUNI', label: fLabel({ data: 'LabelOfficialCommunications' }) },
        { code: 'SPORTCOMMUNI', label: fLabel({ data: 'LabelSportCommunications' }) },
    ]


    useEffect(() => {
        let lbl = data.find(item => item.code === selectedPdfType)?.label
        if (!lbl) { lbl = <Label data={'AllReports'} /> }
        setTextCombo(lbl);
    }, [selectedPdfType]);


    const handleOnChange = (key) => {
        onSelectPdfType(key)
    };

    const options = data?.map((item, index) => {
        return (
            <Dropdown.Item key={item.code} eventKey={item.code} >
                <div className="itemMedal justify-content-left">
                    {item.label}
                </div>
            </Dropdown.Item>
        )
    })

    return (
        <Dropdown onSelect={handleOnChange} id="selectorPdfType" className={"selectorContainer "} >
            <Dropdown.Toggle variant="success" id="dropdown-basic">
                {textCombo}
            </Dropdown.Toggle>
            <Dropdown.Menu>
                {options}
            </Dropdown.Menu>
        </Dropdown>
    );
};


